module.exports = __webpack_public_path__ + "assets/media/1.48fc8803.wav";